import type { HomeFeaturesConfig } from '../types/homeFeatures';

// 機能紹介の草案データ。
// 出典: プレスリリース(newscast.jp/news/1978263)の5機能 + 実装済み機能(Hub/ギャラリー/フォルダ/Lab)。
// フェーズ2でこの内容を backend の SITE_OPTION_DEFAULTS['home_features'] にそのまま移植する。
// 画像が未用意の機能は image を空にしている（管理画面からアップロードして設定する想定）。
export const HOME_FEATURES_DEFAULT: HomeFeaturesConfig = {
  enabled: true,
  featured_count: 2,
  visible_count: 5,
  collapse_rest: true,
  show_for_logged_in: false,
  section_title: 'For game players.',
  section_subtitle:
    'PULSEは、全てのゲームプレイヤーのための、ゲーム記録・管理プラットフォームです。これまでにプレイしたゲームを集約し、あなただけのゲームライブラリを簡単に作成できます。ゲーマーとしての経歴を余すことなく表現し、コミュニティに共有してみましょう。',
  items: [
    {
      id: 'library',
      enabled: true,
      icon: 'Games',
      title: 'ゲームライブラリ',
      description:
        '28万タイトルを超えるデータベースで、ファミコンからPS5・Switchまで、あなたの全てのゲーム体験を詳細なステータスで保存。共有すればプレイヤーとしての経歴が一目で分かります。',
      image: '/image/TOP_profile.png',
      points: [
        'プレイ中・積みゲーなど5つのステータス管理',
        'Steam連携でライブラリをワンクリック同期',
        'リストやランキングも作成可能',
      ],
      link: '/profile',
    },
    {
      id: 'review',
      enabled: true,
      icon: 'Assessment',
      title: 'レビュー・スコアリング',
      description:
        'あなたならではの視点でゲームを記録・評価できます。プレイした時期や機種、プレイ時間を記録し、コミュニティ全体のスコアも参照しながらライブラリを充実させよう。',
      image: '/image/TOP_reviewDia.png',
      points: [
        '独自の視点でスコア・レビューを投稿',
        '自分や友達の嗜好を可視化',
      ],
    },
    {
      id: 'playlog',
      enabled: true,
      icon: 'Timeline',
      title: 'プレイログ分析',
      description:
        '日々のプレイ時間を記録し、統計情報をグラフで可視化。プレイスタイルを客観的に分析でき、ゲームのモチベーション向上にもつながります。',
      image: '',
      points: [
        'プレイ時間やプレイ時期での並び替え',
        '総プレイ数や1年のプレイ数の統計',
      ],
    },
    {
      id: 'profile',
      enabled: true,
      icon: 'AccountCircle',
      title: 'ゲーマープロフィール',
      description:
        'ベストゲームや生涯プレイ数を自動集計したプロフィールをURLで共有。SNSの自己紹介や配信者向けのツールとしても活用できます。',
      image: '',
      points: ['ベストゲーム・生涯プレイ数を自動集計', 'URLでワンタップ共有'],
      link: '/profile',
    },
    {
      id: 'goty',
      enabled: true,
      icon: 'EmojiEvents',
      title: 'GOTY（年間ベスト）',
      description:
        '1年のベストゲームを部門ごとに選出・共有できる機能。「ベストビジュアル」「ベストサウンド」など複数部門でその年のセレクションを残せます。',
      image: '/image/GOTY_bg.jpg',
      points: ['複数部門でのセレクション', 'SNS共有用の画像出力'],
    },
    {
      id: 'hub',
      enabled: true,
      icon: 'Hub',
      title: 'コミュニティHub',
      description:
        'みんなでゲーム情報を持ち寄り、データベースを育てていくコミュニティ機能。投稿が承認されると貢献ポイントが貯まります。',
      image: '',
      points: ['情報投稿でデータベースに貢献', '承認で貢献ポイント獲得'],
      link: '/hub',
    },
    {
      id: 'gallery',
      enabled: true,
      icon: 'Collections',
      title: 'プロフィールギャラリー',
      description:
        'お気に入りのスクリーンショットやアートでプロフィールを彩るギャラリー機能。あなたのゲーム体験をビジュアルで魅せられます。',
      image: '',
      points: ['お気に入り画像でプロフィールを装飾'],
    },
    {
      id: 'lab',
      enabled: true,
      icon: 'Science',
      title: 'PULSE Lab',
      description:
        'キャラクターDBをはじめ、コミュニティで編集できるWiki型のデータベース。ゲームの周辺情報をみんなで充実させていく実験的な機能です。',
      image: '',
      points: ['Wiki型でみんなが編集可能'],
    },
  ],
};
